export const WINDOW_HOVER_DETECT_BORDER = 60;
export const WINDOW_HOVER_DETECT_HEADER_HEIGHT = 30;
export const WINDOW_DEFAULT_GAP = 30;
export const WINDOW_DEFAULT_POSITION: [number, number] = [100, 100];
export const WINDOW_DEFAULT_DIMENSION: [number, number] = [300, 150];
export const WINDOW_TITLEBAR_HEIGHT = 12;
export const ENTWE_PANEL_SORT_DISTANCE = 4;
export const ENTWE_WINDOW_DRAGOVER_DISTANCE = 4;
export const CANCEL_WINDOW_DRAGOVER_DISTANCE = 40;
export const NEWWINDOW_FROM_PANEL_Y_OFFSET = 20;
export const WINDOW_MIN_WIDTH = 200;
export const WINDOW_MIN_HEIGHT = 100;
export const DROP_DETECTION_DELAY = 250;
export const MENU_Z_INDEX = 12345678;
